<template>
	<section
		class="standard_header"
		:class="[type, header_type]"
		:style="{
			'--content-bg-pos': image_position,
			'--quick-links-height':
				quick_links_height - (window.width < 1280 ? 30 : 0) + 'px',
			'--quick-links-height-neg': '-' + 61 + 'px',
		}"
	>
		<div class="container">
			<div class="content">
				<div
					class="text"
					:class="[{ 'no-image': !parsedImage }, type, header_type]"
				>
					<div class="inner">
						<h1
							v-if="title"
							:data-highlightword="getWordsInFirstRow(title)"
							v-html="title"
							:class="[type, header_type]"
						></h1>
						<div
							v-if="description"
							class="body"
							:class="[type, header_type]"
							v-html="description"
						></div>

						<div class="cta_container" v-if="parsedCta">
							<primary-button
								:label="parsedCta.title"
								:link="parsedCta"
							></primary-button>
						</div>
					</div>
				</div>

				<div
					class="image"
					:class="[{ 'no-image': !parsedImage }, type, header_type]"
					v-if="header_type != 'slim'"
				>
					<img
						v-if="parsedImage"
						:src="parsedImage.url"
						:alt="title"
						:class="type"
					/>
				</div>
			</div>

			<slot name="breadcrumbs"></slot>
		</div>
	</section>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		title: {},
		description: {},
		image: {},
		image_position: {
			default: 'center',
		},
		project_details: {},
		type: {},
		header_type: {},
		call_to_action: {},
	},

	computed: {
		parsedImage() {
			if (this.image) {
				return JSON.parse(this.image);
			} else {
				return null;
			}
		},

		parsedProjectDetails() {
			if (this.project_details) {
				return JSON.parse(this.project_details);
			} else {
				return null;
			}
		},

		parsedCta() {
			if (this.call_to_action) {
				return JSON.parse(this.call_to_action);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			this.getQuickLinksHeight();
		},

		handleAccordionToggle(isOpen) {
			console.log('Accordion state:', isOpen);
			const element = this.$refs.quickLinks;

			// Check if the element exists
			if (element) {
				// Use getBoundingClientRect to get the height
				const height = element.getBoundingClientRect().height;

				// Alternatively, you can use offsetHeight
				// const height = element.offsetHeight;
				this.quick_links_height = height;
			} else {
				this.quick_links_height = 0;
			}

			console.log('Quicklinks Height:', this.quick_links_height);
		},

		getQuickLinksHeight() {
			// Access the element via its ref
			const element = this.$refs.quickLinks;

			// Check if the element exists
			if (element) {
				// Use getBoundingClientRect to get the height
				const height = element.getBoundingClientRect().height;

				// Alternatively, you can use offsetHeight
				// const height = element.offsetHeight;
				this.quick_links_height = height;
			} else {
				this.quick_links_height = 0;
			}
		},

		getWordsInFirstRow(paragraph) {
			const words = paragraph.trim().split(' ');

			const firstRowWords = [];
			const tempElement = document.createElement('span');
			document.body.appendChild(tempElement);

			for (const word of words) {
				tempElement.textContent = `${firstRowWords.join(' ')} ${word}`;

				if (tempElement.offsetTop !== firstRowWords.length) {
					break;
				}

				firstRowWords.push(word);
			}

			document.body.removeChild(tempElement);

			return firstRowWords;
		},
	},

	components: { PrimaryButton },

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.standard_header {
	position: relative;
	margin-bottom: 0;
	overflow-x: clip;
	margin-top: 36px;

	.contact & {
		margin-top: 0;

		#breadcrumbs {
			border-bottom: 1px solid var(--white);
		}
	}

	@media (max-width: $tablet) {
		margin-top: 24px;
	}

	.container:first-of-type {
		min-height: 100%;
		position: relative;
		/* max-width: 100%;
		padding-left: calc((100% - 1440px) / 2); */
		/* padding-right: 0; */
		z-index: 1;

		/* @media (max-width: 1520px) {
			padding-left: 40px;
		} */

		@media (max-width: $tablet) {
			grid-template-columns: repeat(4, 1fr);
			/* padding: 0 0; */
		}

		#breadcrumbs {
			position: relative;
			grid-column: 1 / span 12;
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			padding: 24px 0;

			@media (max-width: $tablet) {
				grid-column: 1 / span 4;
				padding: 24px 24px 0;
				display: none;
			}

			&.post,
			&.slim {
				.breadcrumb_container {
					> span {
						display: flex;
						align-items: center;
						flex-wrap: wrap;

						@media only screen and (max-width: 768px) {
							&:first-child a {
								text-indent: -9999px;
								color: var(fpe-blue);

								&::before {
									content: '…';
									text-indent: 0;
								}
							}
						}

						span {
							color: var(--fpe-blue);
							font: normal normal normal 14px/20px var(--primary-font-family);

							&.breadcrumb_last {
								color: var(--fpe-blue);
								font: normal normal normal 14px/20px var(--primary-font-family);
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								width: 350px;
								display: inline-block;

								@media (max-width: $tablet) {
									width: unset;
								}

								*,
								>>> {
									color: var(--fpe-blue);
								}
							}

							a {
								font: normal normal normal 14px/20px var(--primary-font-family);
								color: var(fpe-blue);
								text-decoration: none;

								&:hover {
									text-decoration: underline;
								}
							}

							strong {
								font: normal normal bold 14px/20px var(--primary-font-family);
								color: var(fpe-blue);
							}

							&.divider {
								&::before {
									margin: 0 16px 0;
									font: normal normal 500 11px/20px var(--primary-font-family);
									content: '/';
									display: inline-block;
									color: var(--fpe-blue);
								}
							}

							&:last-child {
								a {
									font: normal normal bold 14px/20px var(--primary-font-family);
								}
							}
						}
					}
				}
			}

			.breadcrumb_container {
				> span {
					display: flex;
					align-items: center;
					flex-wrap: wrap;

					@media only screen and (max-width: 768px) {
						&:first-child a {
							text-indent: -9999px;
							color: var(--fpe-blue);

							&.post {
								color: var(fpe-blue);
							}

							&::before {
								content: '…';
								text-indent: 0;
							}
						}
					}

					span {
						color: var(--fpe-blue);
						font: normal normal 300 14px/20px var(--primary-font-family);

						&.breadcrumb_last {
							color: var(--fpe-blue);
							font: normal normal 300 14px/20px var(--primary-font-family);
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							width: 350px;
							display: inline-block;

							@media (max-width: $tablet) {
								width: unset;
							}

							*,
							>>> {
								color: var(--fpe-blue);
							}
						}

						a {
							font: normal normal 300 14px/20px var(--primary-font-family);
							color: var(--fpe-blue);
							text-decoration: none;

							&:hover {
								text-decoration: underline;
							}

							&.post {
								color: var(fpe-blue);
							}
						}

						strong {
							font: normal normal 300 14px/20px var(--primary-font-family);
							color: var(--fpe-blue);

							&.post {
								color: var(fpe-blue);
							}
						}

						&.divider {
							&::before {
								margin: 0 16px 0;
								font: normal normal 300 11px/20px var(--primary-font-family);
								content: '/';
								display: inline-block;
								color: var(--fpe-blue);
							}
						}

						&:last-child {
							a {
								font: normal normal 300 14px/20px var(--primary-font-family);
							}
						}
					}
				}
			}
		}
	}

	.content {
		grid-column: 1 / span 12;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		column-gap: 0;
		position: relative;
		z-index: 15;
		overflow: hidden;
		column-gap: var(--gutter-tablet-desktop);
		gap: 0;

		.contact & {
			display: none;
		}

		.template-resource &,
		.post-type-archive & {
			padding-bottom: 40px;

			@media (max-width: $tablet) {
				padding-bottom: 0;
			}
		}

		@media (max-width: $tablet) {
			grid-column: 1 / span 4;
			grid-template-columns: repeat(4, 1fr);
			max-height: unset;
			display: flex;
			flex-direction: column;
		}

		.text {
			grid-column: span 6;
			display: flex;
			flex-direction: column;
			justify-content: center;
			gap: 32px;
			position: relative;
			z-index: 5;
			padding-top: 60px;
			padding-bottom: 60px;
			padding-right: 60px;
			padding-left: 60px;
			background: var(--fpe-mid-grey);
			border-radius: 16px;

			body.single &,
			body.template-standard_page & {
				grid-column: span 5;
			}

			&.post {
				padding-top: 0;
				padding-bottom: 30px;
			}

			/* &.no-image {
				grid-column: span 7;
			} */

			@media (min-width: $tablet) {
				padding-top: 60px;
				padding-bottom: 60px;
				padding-right: 60px;
				padding-left: 60px;
			}

			@media (max-width: $tablet) {
				grid-column: span 4;
				padding-top: 60px;
				padding-bottom: 60px;
				padding-right: 40px;
				padding-left: 40px;
			}

			/* @media (max-width: $tablet) and (orientation: portrait) {
				grid-column: span 4;
				height: 100%;
				padding-top: 24px;
				padding-bottom: 24px;
				padding-left: 24px;
				padding-right: 24px;
				justify-content: flex-start;
			} */

			> .inner {
				display: flex;
				flex-direction: column;
				gap: 32px;

				h1 {
					color: var(--fpe-blue);
					margin: 0;
					padding-right: 0;
					padding-top: 0;

					&::first-line {
						color: var(--fpe-blue);
					}

					@media (max-width: $tablet) {
						margin: 0 0 0;
						padding-top: 0;
						padding-right: 0;
					}
				}

				.body {
					color: var(--fpe-blue);
					padding-right: 50px;
					margin: 0;

					&.post,
					&.slim {
						color: var(fpe-blue);
					}

					@media (max-width: $tablet) {
						padding-right: unset;
					}

					&::v-deep {
						p,
						em,
						p em {
							color: var(--fpe-blue);
							padding-right: 0;
							margin: 0;
							font-style: normal;

							@media (max-width: $tablet) {
								padding-right: unset;
							}
						}
					}
				}
			}
		}

		.image {
			grid-column: span 6;
			display: flex;
			flex-direction: column;
			justify-content: center;
			/* position: relative; */
			min-height: 350px;
			max-height: 524px;
			position: relative;
			z-index: 4;
			border-radius: 16px;
			overflow: hidden;
			background: var(--fpe-blue);

			body.single &,
			body.template-standard_page & {
				grid-column: 6 / span 7;
			}

			@media (max-width: 1360px) {
				max-height: 100%;
				aspect-ratio: 4 / 3;
				height: 100%;
			}

			@media (max-width: $tablet) {
				border-left: unset;
				grid-column: span 4;
				min-height: unset;
				max-height: 100%;
				aspect-ratio: 4 / 3;
				order: 0;

				.single-benefit_coverage & {
					display: none;
				}
			}

			> img:not(.device) {
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center center;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/StandardHeader.vue